export default {
    'usd': '$'
}